import { PackageSearch } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { InventoryDiscrepancyReportsPage } from './pages/InventoryDiscrepancyReportsPage'
import { InventoryDiscrepancyReportPage } from './pages/InventoryDiscrepancyReportPage'

export default defineModule({
  id: 'inventory-discrepancy-reports',
  name: 'Discrepancy Reports',
  shortName: 'Discrepancies',
  icon: PackageSearch,
  navSection: 'warehouse',
  navOrder: 11,
  urlNamespace: '/inventory-discrepancy-reports',
  routes: [
    { path: '/', element: InventoryDiscrepancyReportsPage, label: 'Discrepancy Reports' },
    { path: '/new', element: InventoryDiscrepancyReportPage, label: 'New Report' },
    { path: '/$reportId', element: InventoryDiscrepancyReportPage, label: 'Discrepancy Report' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g i d',

  commandPaletteEntries: [
    {
      label: 'Go to Discrepancy Reports',
      keywords: ['discrepancy', 'inventory', 'receipt', 'variance', 'idr', 'report'],
      path: '/',
      group: 'modules',
      shortcut: 'g i d',
    },
    {
      label: 'New Discrepancy Report',
      keywords: ['new discrepancy', 'inventory report', 'file discrepancy', 'new report'],
      path: '/new',
      group: 'actions',
    },
  ],
})
